import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Login from './pages/login';
import LandingPage from './pages/landing-page';
import AccountsOverview from './pages/accounts-overview';
import Dashboard from './pages/dashboard';
import FinancialInsights from './pages/financial-insights';
import Register from './pages/register';
import AccountDetails from './pages/account-details';
import TransactionsManagement from './pages/transactions-management';
import BudgetManagement from './pages/budget-management';
import BudgetAlertsNotifications from './pages/budget-alerts-notifications';
import FinancialGoals from './pages/financial-goals';
import GoalDetailsProgress from './pages/goal-details-progress';
import Settings from './pages/settings';
import ReceiptUploadOCRProcessing from './pages/receipt-upload-ocr-processing';
import DebtPayoffTracker from './pages/debt-payoff-tracker';
import RewardsCenter from './pages/rewards-center';
import FinancialBlog from './pages/financial-blog';
import BlogArticleEditor from './pages/blog-article-editor';
import BlogArticleView from './pages/blog-article-view/index';
import PublicBlog from 'pages/public-blog';
import AdminDashboard from './pages/admin-dashboard';
import UserManagementAnalytics from './pages/user-management-analytics';
import RewardsSystemAdministration from './pages/rewards-system-administration';
import LegalInformation from './pages/legal-information';
import AboutUs from './pages/about-us';
import BillsRecurring from './pages/bills-recurring';
import BillPaymentConfirmation from './pages/bill-payment-confirmation';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/accounts-overview" element={<AccountsOverview />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/financial-insights" element={<FinancialInsights />} />
        <Route path="/register" element={<Register />} />
        <Route path="/account-details" element={<AccountDetails />} />
        <Route path="/accounts/:id" element={<AccountDetails />} />
        <Route path="/transactions-management" element={<TransactionsManagement />} />
        <Route path="/budget-management" element={<BudgetManagement />} />
        <Route path="/budget-alerts-notifications" element={<BudgetAlertsNotifications />} />
        <Route path="/financial-goals" element={<FinancialGoals />} />
        <Route path="/goal-details-progress" element={<GoalDetailsProgress />} />
        <Route path="/bills-recurring" element={<BillsRecurring />} />
        <Route path="/bill-payment-confirmation" element={<BillPaymentConfirmation />} />
        <Route path="/debt-payoff-tracker" element={<DebtPayoffTracker />} />
        <Route path="/rewards-center" element={<RewardsCenter />} />
        <Route path="/financial-blog" element={<FinancialBlog />} />
        <Route path="/blog-article-view/:slug" element={<BlogArticleView />} />
        <Route path="/blog-article-editor" element={<BlogArticleEditor />} />
        <Route path="/public-blog" element={<PublicBlog />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/user-management-analytics" element={<UserManagementAnalytics />} />
        <Route path="/rewards-system-administration" element={<RewardsSystemAdministration />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/receipt-upload-ocr-processing" element={<ReceiptUploadOCRProcessing />} />
        <Route path="/terms" element={<LegalInformation />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;